import { render, staticRenderFns } from "./ModalGenericCriticism.vue?vue&type=template&id=612d0777"
import script from "./ModalGenericCriticism.vue?vue&type=script&lang=js"
export * from "./ModalGenericCriticism.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports